import { createContext } from 'react';
export const TextContext = createContext({
  allDevice: [],
  socketAlarm: [],
  setSocketAlarm: () => {},
  handleAlarmList: () => {},
  socketData: {},
  setSocketData: () => {},
  handleGetSocketData: () => {},
  showDatePicker: true,
  setShowDatePicker: () => {},
  loading: false,
  devicesList: [],
  version: '',
  inverterList: [],
  setEquipmentsError: () => {},
  osSocketPayload: {},
  setOSList: () => {},
  playAlarm: false,
  setPlayAlarm: () => {},
  alarmCount: 0,
  setAlarmCount: () => {},
  alarmHappenSocket: [],
  setAlarmHappenSocket: () => {},
  isErrorModalVisible: {},
  setIsErrorModalVisible: () => {},
});
